import React from "react";
import {
    FactCheckOutlined,
    CoffeeOutlined,
    KeyboardDoubleArrowRightOutlined,
    SlideshowOutlined,
    TaskOutlined,
    ShowChartOutlined,
} from "@mui/icons-material";

interface NotificationIconProps {
    icon: string;
}

export const NotificationIcon: React.FC<NotificationIconProps> = (props: NotificationIconProps) => {
    switch (props.icon.toLowerCase()) {
        // Assessment received, submitted, ending
        case "assessment":
            return <FactCheckOutlined className="notification-icon" style={{ fontSize: 24 }} />;

        // Connection request received, accepted
        case "connections":
            return <CoffeeOutlined className="notification-icon" style={{ fontSize: 24 }} />;

        // Used as a CTA to redirect the user to a relevant page or resource.
        case "view":
            return <KeyboardDoubleArrowRightOutlined className="notification-icon" style={{ fontSize: 24 }} />;

        // Video transcode complete, feedback request, feedback received.
        case "video":
            return <SlideshowOutlined className="notification-icon" style={{ fontSize: 24 }} />;

        // Compliance report ready for viewing.
        case "compliance":
            return <TaskOutlined className="notification-icon" style={{ fontSize: 24 }} />;

        // Activity metrics processed, metrics processing error.
        case "activity":
            return <ShowChartOutlined className="notification-icon" style={{ fontSize: 24 }} />;
        default:
            return <div />;
    }
};
